import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const admin = localStorage.getItem('siyaanish_admin');
  if (!admin) return <Navigate to="/admin/login" replace />;
  try {
    const parsed = JSON.parse(admin);
    // Session expires after 8 hours
    if (Date.now() - parsed.loggedInAt > 8 * 60 * 60 * 1000) {
      localStorage.removeItem('siyaanish_admin');
      return <Navigate to="/admin/login" replace />;
    }
    return children;
  } catch {
    return <Navigate to="/admin/login" replace />;
  }
};

export default AdminRoute;
